/**
 * Going Button Component
 * Toggle going/not going status for an event
 */

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import apiClient from '../api/client';

const GoingButton = ({ eventId, onUpdate }) => {
  const { isAuthenticated } = useAuth();
  const [isGoing, setIsGoing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      checkGoingStatus();
    } else {
      setLoading(false);
    }
  }, [eventId, isAuthenticated]);

  const checkGoingStatus = async () => {
    try {
      const response = await apiClient.get(`/events/${eventId}/going/status`);
      if (response.data.success) {
        setIsGoing(response.data.isGoing);
      }
    } catch (err) {
      console.error('Failed to check going status', err);
    } finally {
      setLoading(false);
    }
  };

  const toggleGoing = async () => {
    setToggling(true);

    try {
      if (isGoing) {
        // Unmark as going
        const response = await apiClient.delete(`/events/${eventId}/going`);
        if (response.data.success) {
          setIsGoing(false);
          if (onUpdate) onUpdate(); // Refresh event data
        }
      } else {
        // Mark as going
        const response = await apiClient.post(`/events/${eventId}/going`);
        if (response.data.success) {
          setIsGoing(true);
          if (onUpdate) onUpdate(); // Refresh event data
        }
      }
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to update going status');
    } finally {
      setToggling(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{ 
        padding: '10px', 
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#666'
      }}>
        Log in to mark as going
      </div>
    );
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <button
      onClick={toggleGoing}
      disabled={toggling}
      style={{
        width: '100%',
        padding: '12px',
        backgroundColor: isGoing ? '#28a745' : '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: toggling ? 'not-allowed' : 'pointer',
        fontSize: '16px',
        fontWeight: 'bold'
      }}
    >
      {toggling ? 'Updating...' : isGoing ? '✓ Going' : 'Mark as Going'}
    </button>
  );
};

export default GoingButton;
